var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// /Users/alex/www/projects/2020/dawson-finance-wordpress/site/web/app/themes/dawsongroup/node_modules/enquire.js/src/index.js
// module id = 1
// module chunks = 0